import { useEffect, useRef } from 'react'

import { useBreakpoints } from '@src/utils/breakpoints.util'

interface UseLockScrollArgs {
  isExpanded: boolean
}

export const useLockScroll = ({ isExpanded }: UseLockScrollArgs) => {
  const scrollTop = useRef(0)
  const breakpoints = useBreakpoints()
  const isMobile = breakpoints.isMobile || breakpoints.isTablet

  useEffect(() => {
    const body = document.querySelector('body')
    const html = document.querySelector('html')

    if (body && html && isMobile) {
      if (isExpanded) scrollTop.current = window.scrollY

      body.style.overflow = isExpanded ? 'hidden' : 'auto'
      body.style.position = isExpanded ? 'relative' : 'unset'
      body.style.height = isExpanded ? '100%' : 'unset'

      html.style.overflow = isExpanded ? 'hidden' : 'auto'
      html.style.height = isExpanded ? '100%' : 'unset'

      if (!isExpanded) window.scrollTo(0, scrollTop.current)

      return () => {
        body.style.overflow = 'auto'
        body.style.position = 'unset'
        body.style.height = 'unset'

        html.style.overflow = 'auto'
        html.style.height = 'unset'
      }
    }
  }, [isExpanded, isMobile])
}
